import { Link } from "react-router-dom";
import { Logo, CmykMark } from "@/components/Brand";
import PAGES from "@/seo/pages.json";
import { useLang } from "@/i18n";
import { useAuth } from "@/context/AuthContext";

const TOOL_PAGES = Object.entries(PAGES).filter(([, p]) => p.main);
const GUIDE_PAGES = Object.entries(PAGES).filter(([, p]) => p.type === "guide");

export const Footer = () => {
  const { t, href, lang } = useLang();
  const { user } = useAuth();
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-12 lg:px-8">
        <div className="md:col-span-4">
          <Logo />
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-500">{t("footer.tagline")}</p>
          <div className="mt-6"><CmykMark size={12} /></div>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-xs font-semibold uppercase tracking-wider text-slate-400">{t("footer.tools")}</p>
          <ul className="mt-4 space-y-2">
            {TOOL_PAGES.map(([k, p]) => (
              <li key={k}><Link to={p.paths[lang]} className="text-sm text-slate-600 hover:text-slate-900">{p[lang].h1}</Link></li>
            ))}
            <li><Link to={href("tools")} data-testid="footer-all-tools" className="text-sm font-semibold text-slate-900 hover:underline">{t("footer.allTools")} →</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-xs font-semibold uppercase tracking-wider text-slate-400">{t("footer.guides")}</p>
          <ul className="mt-4 space-y-2">
            {GUIDE_PAGES.map(([k, p]) => (
              <li key={k}><Link to={p.paths[lang]} className="text-sm text-slate-600 hover:text-slate-900">{p[lang].h1}</Link></li>
            ))}
            <li><Link to={href("guides")} className="text-sm font-semibold text-slate-900 hover:underline">{t("nav.guides")} →</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <p className="font-mono text-xs font-semibold uppercase tracking-wider text-slate-400">{t("footer.account")}</p>
          <ul className="mt-4 space-y-2 text-sm text-slate-600">
            <li><Link to={href("pricing")} className="hover:text-slate-900">{t("footer.pricing")}</Link></li>
            <li><Link to="/painel" className="hover:text-slate-900">{t("footer.dashboard")}</Link></li>
            {!user && <li><Link to="/entrar" className="hover:text-slate-900">{t("footer.login")}</Link></li>}
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-100 py-5 text-center font-mono text-xs text-slate-400">© {new Date().getFullYear()} PixelEdit Pro · {t("footer.rights")}</div>
    </footer>
  );
};
